import React from 'react';
import './Carnival-Things-ToKnow.css';
import Helmet from "react-helmet/es/Helmet";
import {DateTime} from 'luxon';

class CarnivalThings extends React.Component {

    constructor(props) {
        super(props);
        this.booking = this.props.booking;
        this.franchiseData = this.props.franchiseData;
        this.siteConfigData = this.props.siteConfigData;

        this.state = {
        	showConfirmationPopup: false,
            termesAndConditionsAccepted: false,
            
        }

        window.dataLayer = window.dataLayer || [];
        try {
			var oneTrust = window.OnetrustActiveGroups;
			if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && oneTrust  && oneTrust.includes('C0004')) {
			    window.dataLayer.push({
					'event': 'VirtualPageview',
					'virtualPageURL': 'gaVirtualPageURL',
					'virtualPagePath': '/css/guest/payment',
					'virtualPageTitle': 'Customer Self Service / Make a Payment'
	
				});
			} else if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
				window.dataLayer.push({
					'event': 'VirtualPageview',
					'virtualPageURL': 'gaVirtualPageURL',
					'virtualPagePath': '/css/guest/payment',
					'virtualPageTitle': 'Customer Self Service / Make a Payment'
	
				});
			} else {
				console.log("off");    
			}
   
        
        } catch (error) {
            //swallow error
        }
    }
    getStoreAttValue = (attCode) => {
    	let storeAttributeValue='';
    	for(let i=0; i<this.props.siteConfigData.store.storeAttributes.length; i++){
    		if(this.props.siteConfigData.store.storeAttributes[i].attributeCode===attCode){
    			storeAttributeValue = this.props.siteConfigData.store.storeAttributes[i].attributeValue;
    		}
    	}
    	return storeAttributeValue;
    }
    
    getTemplatePropertyValue = (propertyName) => {
    	let templatePropertyValue='';
    	for(let j=0; j<this.props.siteConfigData.templateProperties.length; j++){
    		if(this.props.siteConfigData.templateProperties[j].propertyName===propertyName){
    			templatePropertyValue = this.props.siteConfigData.templateProperties[j].propertyValue;
    		}
    	}
    	return templatePropertyValue;
    }
    
    getSitePropertyValue = (propertyName) => {
    	let sitePropertyValue='';
    	for(let k=0; k<this.props.siteConfigData.siteProperties.length; k++){
    		if(this.props.siteConfigData.siteProperties[k].propertyName===propertyName){
    			sitePropertyValue = this.props.siteConfigData.siteProperties[k].propertyValue;
    		}
    	}
    	return sitePropertyValue;
    }
    getFormattedDate = (dateToFormat) => {
    	let formattedDate = DateTime.fromISO(dateToFormat).toLocaleString(DateTime.DATE_FULL);
    	return formattedDate;
    }
    
    render = () => {
        
        //const attributes = this.props.attributes;
        return (
            <div className="rea-appContainer">
                <Helmet>
                    <title>Customer Self Service / Things to Know Before You Go</title>
                </Helmet>                
                <div class="wth2-css_heading">
            		<h1 class="wth2-pageTopH1" id="css_title_visible">Things to Know Before You Go</h1>
	            </div>
	            <div class="wth2-css_tripToolsHeading">
		        	<div id="css_tripTools">
		            	<a class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth2-ui-btn" href="# " id="css_tripTools_bookingSummary" onClick={e => {e.preventDefault(); this.props.onChangeView('summary-swap', this.booking, this.booking.hash, this.state.updatedBooking)} }>Return to Booking Summary</a>
			        </div>
		        </div>
		        <div class="wth2_css_headdesc">
		        MAXIMIZE YOUR FUN!<br />
		        THINGS TO KNOW BEFORE YOU GO!
		        </div>
		        <p/>

		        <div class="wth2_css_headdesc">Proof of Citizenship</div>
		        The U.S. government requires all guests (including U.S. citizens) to be in possession of valid travel documentation at the pier and throughout the cruise. <a href="https://help.carnival.com/app/answers/list/kw/travel%20documentation" id="css_ccl_citizen" target="_blank" rel="noopener noreferrer">Read more on important travel documentation.</a><p/> 


		        <div class="wth2_css_headdesc">Embarkation (Boarding the Ship)</div>
		        Please check the time of embarkation at your departure port to ensure you have enough time for travel. <a href="http://www.carnival.com/embarkation-information.aspx" id="css_ccl_embarkation" target="_blank" rel="noopener noreferrer">Read more about the Embarkation process. </a><p/>

		        <div class="wth2_css_headdesc">Airport and Pier Transfers</div>
		        Let Carnival get you there - <a href="https://help.carnival.com/app/answers/list/st/3/kw/directions" id="css_ccl_transfers" target="_blank" rel="noopener noreferrer">information on airport and pier transfers.</a><p/>

		        <div class="wth2_css_headdesc">Stateroom Amenities</div>
		        Your stateroom has lots of closet space, individual climate control, Carnival's Comfort Bed Collection for the ultimate night's sleep, plus a complimentary basket of toiletries. <a href="http://www.carnival.com/staterooms.aspx" id="css_ccl_amenities" target="_blank" rel="noopener noreferrer">Read more about the amenities.</a><p />

		        <div class="wth2_css_headdesc">Service Gratuities</div>
		        For your convenience Carnival automatically charges gratuities for dining and stateroom staff to your <a href="https://help.carnival.com/app/answers/detail/a_id/1138/kw/sail%20%26%20sign" id="css_ccl_sailandsign" target="_blank" rel="noopener noreferrer">Sail &amp; Sign &reg; account</a>. Their staff is committed to exceeding your expectations in every way. <a href="https://help.carnival.com/app/answers/category/~/money-gratuity/c/475" id="css_ccl_faqgrat" target="_blank" rel="noopener noreferrer">Please read more about gratuities in Carnival's FAQ section.</a><p/> 

		        <div class="wth2_css_headdesc">What to Wear</div>
		        Casual attire is the order of the day. We suggest shorts, sundresses, tank tops, etc. for the ladies and shorts, khakis, polo shirts and t-shirts will do for the men. <a href="https://help.carnival.com/app/answers/detail/a_id/1125/kw/what%20to%20wear" id="css_ccl_whattowear" target="_blank" rel="noopener noreferrer">Read more on what to wear.</a><p/>

		        <div class="wth2_css_headdesc">Medical Services and Guests with Special Requirements</div>
		        Should you require medical attention while on board, Carnival's Medical Services staff is available to assist you 24 hours a day. Carnival seeks, to the extent feasible, to accommodate guests with special requirements so they are able to enjoy their ships and their facilities. <a href="https://help.carnival.com/app/answers/detail/a_id/2551/kw/medical" id="css_ccl_medical" target="_blank" rel="noopener noreferrer">More information</a><p/>

		        <div class="wth2_css_headdesc">Pregnancy Policy</div>
		        Pregnant guests who enter the 24th week of pregnancy before or at any time during the cruise will not be allowed to sail. Pregnant guests, who will not enter the 24th week before or at any time during the cruise, must submit, prior to departure, a letter from their attending physician certifying that their gestational status is in accordance with this policy, and that the expecting mother is fit to sail. Carnival will not accept any agreement or recommendation from the guest and/or her physician that the policy be waived. <a href="https://help.carnival.com/app/answers/detail/a_id/2543/kw/pregnancy" target="_blank" rel="noopener noreferrer" id="css_ccl_pregnancy">More Information</a><p />

		        <div class="wth2_css_headdesc">Liquor and Beverage Policy</div>
		        What you need to know about Carnival's liquor and beverage check point at the pier, ports of call, gift shops on board, and the consumption of alcohol on board. <a href="https://help.carnival.com/app/answers/detail/a_id/2633/kw/liquor" id="css_ccl_beverage" target="_blank" rel="noopener noreferrer">More information</a><p/>

		        <div class="wth2_css_headdesc">Spa Carnival</div>
		        It's an oasis of relaxation, providing body care treatments and salon services for men and women alike. Also, enjoy Carnival's state-of-the-art fitness center at no extra cost. Visit <a href="https://secure.carnival.com/BookedGuest/GuestManagement/MyCarnival/LogOn?booked=true&returnUrl=%2FBookedGuest%2FRedirect%3Ficid%3DCC_Footer_558%26goal%3Dmybooking" id="css_ccl_spa" target="_blank" rel="noopener noreferrer">My Reservation</a> then click on the Plan Activities tab to pre-book your spa treatment(s).<p />

		        <div class="wth2_css_headdesc">Youth Programs</div>
		        Because kids and teens need a world of fun all their own, Carnival offers many <a href="http://www.carnival.com/onboard/cruise-activities-for-kids" id="css_ccl_kids" target="_blank" rel="noopener noreferrer">programs and activities</a> suited for a wide variety of age groups - Camp Carnival (ages 2-11), Circle "C" (ages 12-14) and Club 02 (ages 15-17).<p/>

		        <div class="wth2_css_headdesc">The Dining Experience</div>
		        <a href="http://www.carnival.com/dining" id="css_ccl_dining" target="_blank" rel="noopener noreferrer">The dining on board is delectable</a> - from elegant to casual, in a sophisticated supper club Steakhouse or under open ocean skies. <p/>

		        <ul style={{ listStyleType: 'circle' }}><li>Main Dining - Enjoy a full menu of unforgettable choices at our Lido Buffet in the Bistro Café and main dining rooms and even in your stateroom, with 24-hour room service.</li>
		        <li>Steakhouse- Carnival's reservations-recommended Steakhouse, with Manhattan-chic settings and menus that include steakhouse favorites, are guaranteed to be your favorite dining spots (Not available on all ships. A nominal fee of $35 per guest is required.)</li>
		        </ul>
		        <p/>
		        <div class="wth2_css_headdesc">Nightly Entertainment</div>
		        Carnival is proud to offer Broadway-style shows, nightclubs and a stellar lineup of talented performers (all at no extra charge). Plus, enjoy hours of fast-paced action at their friendly casinos as you try your luck at the slot machines, blackjack, roulette and even the popular poker tournaments. <a href="http://www.carnival.com/onboard/cruise-entertainment" id="css_ccl_entertainment" target="_blank" rel="noopener noreferrer">More information</a><p/>

		        <div class="wth2_css_headdesc">Your Ship's Highlights</div>
		        <a href="http://www.carnival.com/cruise-ships.aspx" id="css_ccl_activities" target="_blank" rel="noopener noreferrer">Check out what activities your ship has to offer</a>

	        </div>
	            
        );
    }

   
}

export default CarnivalThings;
